import { Link } from 'react-router-dom';
import './LinkCell.scss';

interface LinkCellProps {
  title: string;
  icon: string;
  link: string;
  is_warning?: boolean;
  toReact?: boolean;
  disabled?: boolean;
  enc_id?: number;
  tooltip?: string;
}
const LinkCell: React.FC<LinkCellProps> = ({
  title,
  link,
  icon,
  is_warning = false,
  toReact = false,
  disabled = false,
  enc_id = 0,
  tooltip,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (disabled) {
      e.preventDefault(); // Робить кнопку disabled
    }
  };

  const url_to_zoom = `/object/interactive-map/${link.split('/')[4]}/${link.split('/')[5]}?encounter_zoom=${enc_id}`;

  return (
    <Link
      to={toReact === false ? url_to_zoom : link}
      className={`link-cell-item ${is_warning ? 'bg-warning' : ''} ${disabled ? 'bg-light' : ''}`}
      onClick={handleClick}
      title={tooltip}
    >
      <div className="icon">
        <i className={`${icon} icon rounded-pill fs-14 me-1`} />
      </div>

      <div className="text w-100 d-flex align-items-center justify-content-center">
        <span>{title || 'None'}</span>
      </div>
    </Link>
  );
};

export default LinkCell;
